import React from "react"

import Card from "react-bootstrap/Card"

import FormattedMarkdown from "./formatted_markdown"

const Fees = () => {
  return (
    <Card className="mb-3">
      <Card.Body>
        <FormattedMarkdown id="Fees.Fees" />
      </Card.Body>
    </Card>
  )
}

export default Fees
